import { render, staticRenderFns } from "./PatientStepsTab.vue?vue&type=template&id=53c9c5be&scoped=true&"
import script from "./PatientStepsTab.vue?vue&type=script&lang=js&"
export * from "./PatientStepsTab.vue?vue&type=script&lang=js&"
import style0 from "./PatientStepsTab.vue?vue&type=style&index=0&id=53c9c5be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9c5be",
  null
  
)

export default component.exports